<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <template>
        <v-flex xs6 md6>
          <v-text-field
            v-model="cpf_consulta"
            class="purple-input"
            label="Digite o CPF para começar"
            v-mask="$formmasks.cpf"
          />
        </v-flex>
        <v-flex xs1 md1>
          <v-btn fab dark color="indigo" @click="search_person">
            <v-icon dark>add</v-icon>
          </v-btn>
        </v-flex>
      </template>

      <template v-if="persons.length>0">
        <v-flex xs12 md12>
          <v-form>
            <v-expansion-panel v-model="panel" expand color="grey">
              <v-expansion-panel-content
                class="px-3"
                v-for="(person, index) in persons"
                :key="person.row_count"
              >
                <template v-slot:actions>
                  <v-icon color="primary">$vuetify.icons.expand</v-icon>
                </template>
                <template v-slot:header>
                  <div>
                    <strong>
                      {{index + 1}}
                      <template v-if="person.name">- {{person.name}} </template>
                      <template v-if="person.last_name">{{person.last_name}}</template>
                    </strong>
                  </div>
                </template>
                <v-divider></v-divider>

                <v-layout wrap class="my-1">
                  <v-flex xs12 md5>
                    <v-text-field v-model="person.name" class="purple-input" label="Primeiro nome" />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="person.last_name"
                      class="purple-input"
                      label="Sobrenome"
                    />
                  </v-flex>

                  <v-flex xs12 md1>
                    <v-btn fab dark small color="error" @click="remove_person(person)">
                      <v-icon dark>remove</v-icon>
                    </v-btn>
                  </v-flex>

                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="person.cpf"
                      class="purple-input"
                      label="CPF"
                      v-mask="$formmasks.cpf"
                    />
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="person.pivot.share"
                      class="purple-input"
                      label="Participação"
                      messages="A % que essa pessoa tem sobre o artista."
                      suffix="%"
                      v-mask="['##.##','###.##']"
                    />
                  </v-flex>

                  <!--Dados Bancários-->
                  <v-flex xs12 md6 v-if="!is_company">
                    <v-text-field
                      class="purple-input"
                      label="Banco"
                      messages="Digite o nome do Banco"
                      v-model="person.bank"
                    />
                  </v-flex>

                  <v-flex xs12 md3 v-if="!is_company">
                    <v-text-field
                      class="purple-input"
                      label="Agência"
                      messages="Digite a agência sem digito verificador"
                      v-model="person.bank_agency"
                    />
                  </v-flex>
                  <v-flex xs12 md3 v-if="!is_company">
                    <v-text-field
                      class="purple-input"
                      label="Conta"
                      messages="Digite a conta do seu banco com o digito verificador"
                      v-model="person.bank_account"
                    />
                  </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-form>
        </v-flex>
        <!--v-flex xs1 md1 right >
          <v-btn fab dark color="indigo" @click="add_person">
            <v-icon dark>add</v-icon>
          </v-btn>
        </v-flex-->
      </template>
    </v-layout>
  </v-container>
</template>

<script>
import PersonService from "../../app/Rest/person";

const personService = PersonService.build();

export default {
  data() {
    return {
      count_persons: 0,
      panel: [true],
      persons: [], //{ row_count: 0, expanded: true }
      items: [],
      select: null,
      cpf_consulta: null
    };
  },
  props: {
    personsdata: Array,
    is_company: Number
  },
  watch: {
    persons: function() {
      //this.$emit("persons_data", this.persons);
      
    },
    personsdata: function() {      
      this.persons = this.personsdata.map( e=>{ e.row_count = this.count_persons++; return e; })
    }
  },
  methods: {
    search_person: function() {
      console.log(this.cpf_consulta);
      if (this.cpf_consulta == null || this.cpf_consulta == "") {
        this.add_person(null);
      }
      else{
        personService.getOneByCpf(this.cpf_consulta).then(e => {
          if (e.items) {
            this.add_person(e.items.person);
          } else {
            this.add_person(null);
          }
        });
      }
    },
    //Adiciona uma pessoa ao conjunto atual
    add_person: function(tp_person) {
      this.count_persons = this.count_persons + 1;
      //panel.push(false);

      
      console.log("add_person inicial", tp_person,this.count_persons);
      
      if (tp_person != null) {
        tp_person.row_count = this.count_persons;
        //se nao houver o pivot, criamos um temporario
        if (tp_person.pivot == null) {
          tp_person.pivot = { share: "" };
        }

        console.log("add_person meio_if", tp_person,this.count_persons);

      } else {
        tp_person = {};
        
        

        tp_person = {
          row_count: this.count_persons,
          cpf: this.cpf_consulta,          
          pivot: {share:""}
        };

        console.log("add_person meio_else", tp_person,this.count_persons);

      }
      
      this.persons.push(Object.assign({}, tp_person));
      
      this.cpf_consulta = null;
      console.log("add_person final", tp_person,this.count_persons);
      return;
    },
    remove_person: function(indice) {
      var t_faixas = [];
      this.persons.forEach(element => {
        if (indice.row_count != element.row_count) {
          t_faixas.push(element);
        }
      });
      this.persons = [...t_faixas];
      this.count_persons = (this.count_persons - 1) < 0 ? 0 : this.count_persons - 1;
      console.log('remove_person', this.persons);
    }
  }
};
</script>